import logo from '../assets/logo.png'
import styles from './Logo.module.css'

export default function Logo({imgSize}) {
  return (
    <div className={styles.imageContainer}>
      <img src={logo} alt='oryenta' height={imgSize}></img>
    </div>
  );
}